import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { APP_ROUTES } from './app.routes';
import { SharedModule } from './shared/shared.module';
import { BannerComponent } from './components/banner/banner.component';
import { AboutComponent } from './components/about/about.component';
import { ServicesComponent } from './components/services/services.component';
import { ContactoComponent } from './components/contacto/contacto.component';
import { WorksComponent } from './components/works/works.component';
import { CounterComponent } from './components/counter/counter.component';
import { TestimonialComponent } from './components/testimonial/testimonial.component';
import { MailService } from './services/mail.service';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { SingleServicioComponent } from './single-servicio/single-servicio.component';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    BannerComponent,
    AboutComponent,
    ServicesComponent,
    ContactoComponent,
    WorksComponent,
    CounterComponent,
    TestimonialComponent,
    SingleServicioComponent
  ],
  imports: [
    BrowserModule,
    SharedModule,
    HttpClientModule,
    APP_ROUTES,
    ScrollToModule.forRoot(),
    FormsModule
  ],
  providers: [MailService],
  bootstrap: [AppComponent]
})
export class AppModule { }
